<template>
  <div>
    <button @click="closeUppy" class="close-x" data-testid="closeButton">
      <img class="close-icon" src="@/assets/images/close_icon_white.svg" alt=""/>
    </button>
    <dashboard
      :uppy="uppy"
      :plugins="displayPlugins"
      :props="{
        proudlyDisplayPoweredByUppy: false,
        locale: customDashboardHebrew,
      }"
    />
  </div>
</template>

<script>
import Uppy from '@uppy/core'
import { Dashboard } from '@uppy/vue'
import AWS3 from '@uppy/aws-s3'
import ms from 'ms'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import config from '@/config.js'
import { uppyPlugins, languagePlugins } from '@/services/uppy/uppy-imports.js'
import { uploadConfig } from '@/constants.js'
import { mapState, mapActions } from 'vuex'
import { editUrl } from '@/utilityFunctions.js'
import Tus from '@uppy/tus'
import Vimeo from '@/services/uppy/vimeo-plugin'

export default {
  name: 'App',
  props: ['uploadType'],
  components: { Dashboard },
  data () {
    return {
      type: this.$route.params.type,
      uppyLang: '',
      displayPlugins: null,
      typesOfFiles: null,
      customDashboardHebrew: null,
      customLinkHebrew: null,
      uppy: null
    }
  },
  created () {
    this.setLanguage()
    const companionUrl = config.companionUrl
    this.setSuccess(null)
    const pluginsArray = Object.keys(uppyPlugins)
    switch (this.uploadType) {
      case 'image':
        this.typesOfFiles = uploadConfig.allowedFileTypes.imageTypes
        this.displayPlugins = pluginsArray
        break
      case 'video':
        this.typesOfFiles = uploadConfig.allowedFileTypes.videoTypes
        break
      case 'audio':
        this.typesOfFiles = uploadConfig.allowedFileTypes.audioTypes
        break
      case 'attachment':
        this.typesOfFiles = uploadConfig.allowedFileTypes.attachmentTypes
        break
      default:
        this.typesOfFiles = uploadConfig.allowedFileTypes.fileTypes
    }
    if (!this.displayPlugins) {
      this.displayPlugins = pluginsArray.filter(plugin => plugin !== 'Url')
    }
    this.uppy = new Uppy({
      restrictions: {
        maxTotalFileSize: this.uploadType === 'video' ? uploadConfig.maxVimeoUploadSize : uploadConfig.maxUploadSize,
        allowedFileTypes: this.typesOfFiles,
        maxNumberOfFiles: 1
      },
      proudlyDisplayPoweredByUppy: true,
      locale: this.uppyLang,
      autoProceed: true
    })
    this.uppy.use(uppyPlugins.GoogleDrive, {
      companionUrl
    })
      .use(uppyPlugins.Dropbox, {
        companionUrl
      })
      .use(uppyPlugins.Url, {
        companionUrl,
        locale: this.uppyLang
      })
      .on('file-added', (file) => {
        console.log(file.name)
      })
      .on('complete', (result, self = this) => {
        if (result.successful.length) {
          console.log(result)
          const correctUrl = self.uploadType === 'video' ? result.successful[0].embedUrl : editUrl(result.successful[0].uploadURL)
          if (self.uploadType === 'image') {
            self.setUploadImageUrl(correctUrl)
          } else if (self.uploadType === 'attachment') {
            self.setUploadAttachmentUrl(correctUrl)
          } else {
            const resultObj = result.successful[0]
            resultObj.uploadURL = correctUrl
            self.setUploadFile(resultObj)
          }
          self.setSuccess(true)
          this.$emit('closeUppy')
        } else {
          self.setSuccess(false)
        }
      })
      .on('upload-error', (file, error, request) => {
        console.log(error)
      })
    if (this.uploadType === 'video') {
      this.uppy
        .use(Tus, {})
        .use(Vimeo, {
          id: 'vimeo-uploader',
          accessToken: this.videoUploadApiCreds.token
        })
    } else {
      this.uppy
        .use(AWS3, {
          limit: 2,
          timeout: ms('1 minute'),
          companionUrl,
          companionHeaders: {
            'uppy-auth-token': this.appConfig.authToken,
            'library-slug': this.$store.state.base.library.slug,
            source: 'library'
          }
        })
    }
  },
  watch: {
    lang () {
      this.setLanguage()
    }
  },
  computed: {
    ...mapState({
      lang: state => state.base.lang.lang,
      videoUploadApiCreds: state => state.base.library.metadata.VIDEO_UPLOAD_API_CREDS
    })
  },
  methods: {
    setLanguage () {
      if (this.lang === 'עברית') {
        this.uppyLang = languagePlugins.Hebrew
        this.customDashboardHebrew = {
          strings: {
            dropPasteImport: 'גררו לכאן קבצים, הדביקו או ייבאו מ'
          }
        }
        this.customLinkHebrew = {
          strings: {
            import: 'ייבוא'
          }
        }
      } else {
        this.uppyLang = languagePlugins.English
      }
    },
    closeUppy () {
      this.$emit('closeUppy')
    },
    ...mapActions(['setSuccess', 'setUploadFile', 'setUploadImageUrl', 'setUploadAttachmentUrl'])
  },
  beforeDestroy () {
    this.uppy.close()
  }
}
</script>
<style lang="scss">
.uppy-size--md .uppy-DashboardTab-btn {
  width: 56px;
  margin: 0 20px;
}

.uppy-Dashboard-AddFiles-title {
  border: 2px dashed #b0b0b2;
  border-radius: 2px;
  width: 330px;
  height: 190px;
  padding: 15px;
  position: relative;
  color: #7C7C7C;
  font-size: 18px;
  font-family: "Arimo", sans-serif;
  background-image: url("../assets/images/upload_image_btn.svg");
  background-position: center 70px;
  background-repeat: no-repeat;
  background-color: #f3f3f3;
  background-size: 100px;
}

.uppy-DashboardTab[data-uppy-acquirer-id="MyDevice"] svg {
  visibility: hidden !important;
}

.uppy-DashboardTab-btn::before {
  position: absolute;
  height: 30px;
  margin: 0 -15px;
}

.uppy-DashboardTab[data-uppy-acquirer-id="MyDevice"] .uppy-DashboardTab-btn::before {
  content: url("../assets/images/computer_upload_icon.svg");
}

.uppy-DashboardTab[data-uppy-acquirer-id="GoogleDrive"] svg {
  visibility: hidden !important;
}

.uppy-DashboardTab[data-uppy-acquirer-id="GoogleDrive"] .uppy-DashboardTab-btn::before {
  content: url("../assets/images/google_drive_logo.svg");
}

.uppy-DashboardTab[data-uppy-acquirer-id="Dropbox"] svg {
  visibility: hidden !important;
}

.uppy-DashboardTab[data-uppy-acquirer-id="Dropbox"] .uppy-DashboardTab-btn::before {
  content: url("../assets/images/Dropbox_Icon.svg");
}

.uppy-DashboardTab[data-uppy-acquirer-id="Url"] svg {
  visibility: hidden !important;
}

.uppy-DashboardTab[data-uppy-acquirer-id="Url"] .uppy-DashboardTab-btn::before {
  content: url("../assets/images/link_icon.svg");
}

.uppy.uppy-Informer p {
  background-color: #E32127;
}

.uppy-Url {
  display: flex;
  gap: 10px;
}

.uppy-DashboardContent-panel {
  background-color: #fff;
}

.rtl .uppy-Root {
  direction: rtl !important;
}
</style>
<style lang="scss" scoped>
.close-x {
  inset-inline-end: 23%; top: 50%; transform: translate(0%, -260px);

  &:after, &:before {
    background-color: #fff;
  }
}
</style>
